/* eslint-disable @typescript-eslint/no-var-requires */
export * from './entry-production';
import { InContextTools } from './InContextTools';

export const DevTools = InContextTools;
